export type ReportType = "false-positive" | "false-negative";

export type Values = {
  type: ReportType;
  comment: string;
  contact?: string;
};

export type ValuesKey = keyof Values;
